import { can, capabilityForPath } from "../../modules/settings/accessRoles";

// Drops menu items whose page needs a role the user doesn't have, then any group left empty.
const filterItems = (items, user) =>
  items
    .map((item) => (item.content ? { ...item, content: filterItems(item.content, user) } : item))
    .filter((item) => {
      if (item.content) return item.content.length > 0;
      const capability = capabilityForPath(item.to);
      return !capability || can(user, capability);
    });

export default function filterNavForUser(sections, user) {
  return sections
    .map((section) => ({ ...section, content: filterItems(section.content || [], user) }))
    .filter((section) => section.content.length > 0);
}
